import React from "react";

import classnames from "classnames";
import { $Diff } from "utility-types";
import { withStyleProps } from "Utils/styleProps";

type Props = {
  inline?: boolean;
  level: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

  /**
  @ignore
  * */
  classes?: string;
  styLevel?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

  /**
  @ignore
  * */
  className?: string;

  /**
  @ignore
  * */
  children: React.ReactNode;
};

const Header = ({ inline, level, styLevel, classes, className: additionalClassName, children, ...rest }: Props) => {
  const className = classnames(
    "Header",
    `Header--h${styLevel || level}`,
    {
      "Header--inline": inline,
    },
    classes,
    additionalClassName,
  );
  const element = React.createElement(
    `h${Math.min(level, 6)}`,
    {
      className,
      ...rest,
    },
    [children],
  );
  return element;
};

const defaultStyleProps = {
  mb: 2,
};

// Create a component that calls the base Header with a hard-coded number, and
// also works with style props. This is done this way instead of a normal HOC to
// help keep the React dev tools looking more sane.
const makeHeader = (number: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8) => {
  const Component = (
    props: $Diff<
      Props,
      {
        level: number;
      }
    >,
  ) =>
    Header({
      level: number,
      ...props,
    });

  Component.displayName = `H${number}`;
  return withStyleProps(Component, defaultStyleProps);
};

export const H1 = makeHeader(1);
export const H2 = makeHeader(2);
export const H3 = makeHeader(3);
export const H4 = makeHeader(4);
export const H5 = makeHeader(5);
export const H6 = makeHeader(6);
export default withStyleProps(Header, defaultStyleProps);
